class StreetParkingService {
    constructor(
        private apiUrl: string = "/api/v1",
        private apiToken: string = null
    ) {}

    public async getStreetParkingSection(sectionCode: string): Promise<any>  {
        if (!sectionCode) throw new Error("Section code is required");

        return await this.getJson("StreetParking/sections/2", {
            sectionCode: sectionCode.trim().toUpperCase().replace(/\s+/g, ""),
        });

    };

    public async getParkingMachine(code: string): Promise<any> {
        if (!code) throw new Error("Machine code is required");

        return await this.getJson("StreetParking/parkMachines/2", {
            parkMachineCode: code.toUpperCase(),
        });
    }

    private getJson = async (url: string, params?: Record<string, any>): Promise<any> => {
        const queryString = params ? `?${new URLSearchParams(params).toString()}` : "";

        const options: RequestInit = {
            method: "GET",
            headers: {
                Accept: "application/json",
                apiKey: this.apiToken,
            },
        };

        try {
            const response = await fetch(`${this.apiUrl}/${url}${queryString}`, options);

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            return response.json();
        } catch (error: any) {
            console.error("Fetch Error:", error.message);
            throw error;
        }
    };
}

export default StreetParkingService;
